import { useEffect } from "react";
import { Link } from "react-router-dom";

// Flags itself noindex directly rather than pulling in the full useSeoMeta
// (title/OG/canonical) machinery. The origin already serves `noindex, follow` for unknown
// paths and missing skill/docs slugs (backend/app/services/seo.py), so this is the rendered-DOM
// half of the same signal — it has to stay in agreement with the server, since Google reads
// `robots` from both. The cleanup on unmount restores whatever the server set, so a
// client-side navigation away from a 404 doesn't leave the next page noindexed.
export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found — SkillPatch";
    let el = document.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    const prev = el.getAttribute("content");
    el.setAttribute("content", "noindex");
    return () => {
      if (prev) el!.setAttribute("content", prev);
      else el?.remove();
    };
  }, []);
  return (
    <main className="mx-auto flex max-w-md flex-col items-center px-6 py-28 text-center">
      <p className="text-5xl font-bold text-primary [text-shadow:0_0_40px_rgba(139,92,246,0.35)]">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold tracking-tight">Page not found</h1>
      <p className="mt-2 text-sm text-text/55">
        The page you’re looking for doesn’t exist or may have been moved.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-lg bg-primary px-5 py-2.5 font-medium text-white transition hover:opacity-90"
      >
        Back home
      </Link>
    </main>
  );
}
